/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAIDocumentSummaryViewModel } from "../types/TutorAIDocumentSummaryViewModel.ts";
import { tutorAIDocumentStatusSchema } from "./tutorAIDocumentStatusSchema.ts";

export const tutorAIDocumentSummaryViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("Identificador único do documento."),
  ),
  fileName: z
    .string()
    .describe("Nome do arquivo armazenado no storage (gerado internamente).")
    .nullish(),
  originalFileName: z
    .string()
    .describe("Nome original do arquivo enviado pelo usuário.")
    .nullish(),
  status: z.optional(
    z
      .lazy(() => tutorAIDocumentStatusSchema)
      .describe("1 = Pending | 2 = Imported | 3 = OutOfSync | "),
  ),
  sizeBytes: z.optional(
    z.number().int().describe("Tamanho do arquivo em bytes."),
  ),
  chunkCount: z.optional(
    z
      .number()
      .int()
      .describe(
        "Quantidade de chunks gerados pelo processo de indexação. Zero enquanto o documento não for importado.",
      ),
  ),
  personId: z.optional(
    z.number().int().describe("ID da pessoa que enviou o documento."),
  ),
  personName: z
    .string()
    .describe("Nome da pessoa que enviou o documento.")
    .nullish(),
  personEmail: z
    .string()
    .describe("E-mail da pessoa que enviou o documento.")
    .nullish(),
  createdAt: z.optional(
    z
      .string()
      .datetime()
      .describe("Data e hora de criação do registro do documento (UTC)."),
  ),
  updatedAt: z.optional(
    z
      .string()
      .datetime()
      .describe("Data e hora da última atualização do documento (UTC)."),
  ),
}) as unknown as ToZod<TutorAIDocumentSummaryViewModel>;
